
import biometricReducer from "./biometricReducer";
import verifyCustomerReducer from "./verifyCustomerReducer";

export const supervisorReducer = {
  biometricReducer,
  verifyCustomerReducer
}
